import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SelectClient from "../../Components/SelectClient";
import DashboarProjet from "./DashboardProjet";
import { Container } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useProjet } from "../../Contexts/projet";


const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    marginBottom: 30
  },
}));


function Agence() {
  const classes = useStyles();
  let history = useHistory();
  const { setFolder, folder } = useProjet();

  const onSelect = folder => {
    setFolder(folder);
    history.push(`/agence/${folder.title}`)
  }

  return (
    <div>
      <Container maxWidth="lg" className={classes.container}>
        <SelectClient onSelect={onSelect}/>
      </Container>
      {folder && <DashboarProjet isClient={false}/>}
    </div>
  );
}

export default Agence;
